<template>
  <div class="message-attach flex-row">
    <div class="flex-column">
      <p
        v-if="file.download_url"
        @click="generateURL(file.download_url)"
        class="message-attach__text generated-link"
      >
        {{ file.name }}
      </p>
      <p v-else class="primary message-attach__text">{{ file.name }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    file: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    generateURL(messUrl) {
      const e = document.createElement('a');

      let url =
        process.env.VUE_APP_BASE_PATH +
        (process.env.VUE_APP_BASE_PATH.lastIndexOf('/') ==
        process.env.VUE_APP_BASE_PATH.length - 1
          ? ''
          : '/') +
        messUrl;

      e.href = url;
      e.target = '_blank';
      e.download = url.substr(url.lastIndexOf('/') + 1);
      document.body.appendChild(e);
      e.click();
      document.body.removeChild(e);
    }
  }
};
</script>

<style lang="scss" scoped>
.message-attach {
  .generated-link {
    cursor: pointer;

    &:hover {
      color: $blue64;
    }
  }
}
</style>

<style lang="scss">
.flex-row {
  display: flex;
  flex-direction: row;
}

.flex-column {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.message-attach {
  padding: 10px 12px;
  margin: 4px 0 0 0;
  background: $grey8;
  border-radius: 4px;
  overflow: hidden;
  word-break: break-word;

  &__text {
    font-size: 14px;
    line-height: 20px;
    text-decoration: unset;
    color: $grey80;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }

  .attach-btn {
    height: 40px;
    width: 40px;
    min-width: 40px;
    margin-right: 8px !important;

    .button-content {
      margin: 0;
    }
  }
}
</style>
